import { Component, OnInit, OnDestroy } from '@angular/core';
import { IEventListItem } from '@core/interfaces/event/event-list-item.interface';
import { cardRevealAnimation } from '@shared/animations/card-reveal.animation';
import { Callout } from '@shared/models/callout/callout.model';
import { EventsService } from '@core/services/event/events.service';
import { take, finalize } from 'rxjs/operators';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { SearchOrder } from '@core/enums/search-order.enum';
import { ListResult } from '@core/models/list-result/list-result.model';
import { EventListItem } from '@core/models/event/event-list-item.model';
import { emptyListCallout } from '@shared/config/empty-list-callout.config';
import { AAGUID, AppError, Browser, SsrService } from '@interticket/core';
import { ErrorService } from 'common';
import { ConfigService } from '@core/services/config/config.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [cardRevealAnimation],
})
export class MainComponent implements OnInit, OnDestroy {

  readonly emptyListCallout: Callout = new Callout(emptyListCallout);
  errorCallout: Callout;

  eventList: IEventListItem[];
  highlightedPrograms: IEventListItem[];
  calendarEventList: IEventListItem[];

  sideBarEventId: AAGUID;
  selectedEventId: AAGUID;
  partnerName: string;
  isLoading: boolean;
  isLoadingCalendar: boolean;
  isModalOpen: boolean;
  showVenueMap: boolean;
  displayCalendar: boolean;

  constructor(
    private ssrService: SsrService,
    private eventsService: EventsService,
    private errorService: ErrorService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.showVenueMap = this.configService.siteConfig.showVenueMap;
    this.displayCalendar = this.configService.siteConfig.displayCalendar;
    this.partnerName = this.configService.siteConfig.platformLabel.join('');

    this.fetchEventList();
    this.fetchCalendarEvents();
  }

  ngOnDestroy(): void {
    this.closeSidebar();
  }

  private createHighlightedPrograms(): void {
    if (this.eventList.length > 3) {
      this.highlightedPrograms = this.eventList.splice(0, 3);
    } else {
      this.highlightedPrograms = this.eventList;
    }
  }

  private fetchEventList(): void {
    const searchParams: SearchParams = new SearchParams({
      limit: 9,
      pageIndex: 0,
      orderBy: 'startDate',
      order: SearchOrder.ASC,
    });

    this.isLoading = true;

    this.eventsService.getList(searchParams)
      .pipe(
        take(1),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (listResult: ListResult<IEventListItem, EventListItem>) => {
          this.eventList = listResult.results;
          this.createHighlightedPrograms();
        },
        error: (error: AppError) => this.errorCallout = this.errorService.getErrorCallout(error),
      });
  }

  private fetchCalendarEvents(): void {
    this.isLoadingCalendar = true;
    this.eventsService.getCalendarEvents()
      .pipe(
        take(1),
        finalize(() => this.isLoadingCalendar = false)
      )
      .subscribe({
        next: (listResult: ListResult<IEventListItem, EventListItem>) => this.calendarEventList = listResult.results,
      });
  }

  @Browser()
  onBuyTicket(eventId: AAGUID): void {
    this.sideBarEventId = eventId;
    // disable scroll on opening sidebar
    this.ssrService.document.body.style.overflow = 'hidden';
  }

  @Browser()
  closeSidebar(): void {
    this.sideBarEventId = null;
    // enable scroll on closing sidebar
    this.ssrService.document.body.style.overflow = 'auto';
  }

  onHasNoTicket(eventId: AAGUID): void {
    this.isModalOpen = true;
    this.selectedEventId = eventId;
  }

  trackByFn(index: number): number {
    return index;
  }

}
